import { useEffect, useRef, useState } from "react";

const INTERACTIVE_SELECTOR =
  'a, button, [role="button"], input, textarea, select, label, .MuiButton-root, .MuiIconButton-root, .MuiListItem-button, [data-cursor-hover]';

export const CustomCursor = () => {
  const cursorRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.matchMedia || !window.matchMedia("(pointer: fine)").matches) {
      return;
    }
    setEnabled(true);
  }, []);

  useEffect(() => {
    if (!enabled) return;
    const cursor = cursorRef.current;
    if (!cursor) return;

    const evaluateAt = (x, y) => {
      const el = document.elementFromPoint(x, y);
      if (el && el.closest && el.closest(INTERACTIVE_SELECTOR)) {
        cursor.classList.add("aw-cursor-active");
      } else {
        cursor.classList.remove("aw-cursor-active");
      }
    };

    const onMove = (e) => {
      cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      evaluateAt(e.clientX, e.clientY);
    };

    const onMouseDown = () => cursor.classList.add("aw-cursor-clicking");
    const onMouseUp = () => cursor.classList.remove("aw-cursor-clicking");
    const onClick = () => {
      cursor.classList.remove("aw-cursor-active", "aw-cursor-clicking");
    };

    const onLeaveWindow = () => cursor.classList.add("aw-cursor-hidden");
    const onEnterWindow = () => cursor.classList.remove("aw-cursor-hidden");

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("click", onClick);
    document.documentElement.addEventListener("mouseleave", onLeaveWindow);
    document.documentElement.addEventListener("mouseenter", onEnterWindow);

    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("click", onClick);
      document.documentElement.removeEventListener("mouseleave", onLeaveWindow);
      document.documentElement.removeEventListener("mouseenter", onEnterWindow);
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div ref={cursorRef} className="aw-cursor aw-cursor-hidden">
      <svg
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1 L14 12 L8 12.5 L5.5 19 Z"
          fill="#4c004c"
          stroke="#ffffff"
          strokeWidth="1"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
